import common from './common'

const filter = {
  ...common.button,
  color: `alpha`,
  bg: `white`,
  borderColor: `alpha`,
  borderWidth: `1px`,
  borderStyle: `solid`,
  ':hover': {
    color: `omegaLighter`,
    bg: `omegaDark`,
    borderColor: `omegaDark`
  },
  gap: 2,
  ':active': {
    color: 'white',
    bg: `alpha`
  },
}

export default filter